import { render, staticRenderFns } from "./ai02WJZHGameVue.vue?vue&type=template&id=58ac153f&scoped=true"
import script from "./ai02WJZHGameVue.vue?vue&type=script&lang=js"
export * from "./ai02WJZHGameVue.vue?vue&type=script&lang=js"
import style0 from "./ai02WJZHGameVue.vue?vue&type=style&index=0&id=58ac153f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac153f",
  null
  
)

export default component.exports